import React from 'react';
import AppImage from '@/components/ui/AppImage';
import SEOHeading from '@/components/common/SEOHeading';

interface GalleryImage {
  id: number;
  src: string;
  alt: string;
  caption: string;
}

interface FacilityGalleryProps {
  images: GalleryImage[];
}

const FacilityGallery = ({ images }: FacilityGalleryProps) => {
  return (
    <section className="mb-16">
      <div className="mb-8 text-center">
        <SEOHeading level={2} className="mb-3">
          Our Breeding Facility
        </SEOHeading>
        <p className="text-muted-foreground">
          A clean, spacious, and loving environment for our Labradors
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {images.map((image) => (
          <div
            key={image.id}
            className="group overflow-hidden rounded-xl shadow-warm transition-smooth hover:shadow-warm-lg"
          >
            <div className="relative h-64 overflow-hidden">
              <AppImage
                src={image.src}
                alt={image.alt}
                className="h-full w-full object-cover transition-smooth group-hover:scale-105"
                width={400}
                height={300}
              />
            </div>
            <div className="bg-card p-4">
              <p className="text-sm font-medium text-foreground">
                {image.caption}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FacilityGallery;